<div class="card max-w-2xl mx-auto">
  <!-- Header -->
  <div class="px-6 py-4 border-b border-gray-200 dark:border-gray-700 flex items-center justify-between">
    <h3 class="text-xl font-semibold text-gray-900 dark:text-white">
      Create User
    </h3>
<!--     <button 
      (click)="returnprev()" 
      class="bg-orange-600 hover:bg-orange-700 text-white px-4 py-2 rounded-md font-medium transition-colors flex items-center gap-2">
      <ng-icon name="heroArrowLeft"></ng-icon>
      Exit -->
<!--     </button> -->
  </div>

  <!-- Card Body -->
  <div class="p-6">
    <form [formGroup]="registerForm" (ngSubmit)="register()" class="space-y-6">
      <!-- Name Fields Row -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div class="space-y-2">
          <label for="input-first-name" class="block text-sm font-medium text-gray-900 dark:text-white">
            First Name
          </label>
          <kendo-textbox 
            autofocus
            id="input-first-name" 
            class="w-full" 
            formControlName="firstname" 
            placeholder="First name"
            [attr.aria-invalid]="f['firstname'].invalid && f['firstname'].touched ? true : null">
          </kendo-textbox>
          <span *ngIf="f['firstname']?.errors?.required && f['firstname'].touched"
            class="text-sm text-red-600 dark:text-red-400">
            First name is required
          </span>
        </div>
        <div class="space-y-2">
          <label for="input-last-name" class="block text-sm font-medium text-gray-900 dark:text-white">
            Last Name
          </label>
          <kendo-textbox 
            id="input-last-name" 
            class="w-full" 
            formControlName="lastname" 
            placeholder="Last name"
            [attr.aria-invalid]="f['lastname'].invalid && f['lastname'].touched ? true : null">
          </kendo-textbox>
          <span *ngIf="f['lastname']?.errors?.required && f['lastname'].touched"
            class="text-sm text-red-600 dark:text-red-400">
            Last name is required
          </span>
        </div>
      </div>

      <!-- Contact Information Row -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div class="space-y-2">
          <label for="input-phone" class="block text-sm font-medium text-gray-900 dark:text-white">
            Mobile Phone
          </label>
          <kendo-maskedtextbox 
            id="input-phone" 
            mask="000-000-0000"
            class="w-full" 
            formControlName="phonenumber" 
            placeholder="Mobile phone"
            [attr.aria-invalid]="f['phonenumber'].invalid && f['phonenumber'].touched ? true : null">
          </kendo-maskedtextbox>
          <span *ngIf="f['phonenumber']?.errors?.required && f['phonenumber'].touched"
            class="text-sm text-red-600 dark:text-red-400">
            Mobile number is required
          </span>
        </div>
        <div class="space-y-2">
          <label for="input-email" class="block text-sm font-medium text-gray-900 dark:text-white">
            Email Address
          </label>
          <kendo-textbox 
            id="input-email" 
            class="w-full" 
            formControlName="email" 
            placeholder="Email address"
            [attr.aria-invalid]="f['email'].invalid && f['email'].touched ? true : null">
          </kendo-textbox>
          <span *ngIf="f['email']?.errors?.required && f['email'].touched"
            class="text-sm text-red-600 dark:text-red-400">
            Email address is required
          </span>
          <span *ngIf="f['email']?.hasError('pattern') && f['email'].touched"
            class="text-sm text-red-600 dark:text-red-400">
            Invalid email address format
          </span>
        </div>
      </div>

      <!-- Username Field -->
      <div class="space-y-2">
        <label for="input-username" class="block text-sm font-medium text-gray-900 dark:text-white">
          Username
        </label>
        <kendo-textbox 
          id="input-username" 
          class="w-full" 
          formControlName="username"
          placeholder="Username"
          [attr.aria-invalid]="f['username']?.invalid && f['username']?.touched ? true : null">
        </kendo-textbox>
        <span *ngIf="f['username']?.errors?.required && f['username']?.touched"
          class="text-sm text-red-600 dark:text-red-400">
          Username is required
        </span>
        <span *ngIf="f['username']?.hasError('pattern') && f['username']?.touched"
          class="text-sm text-red-600 dark:text-red-400">
          Invalid username format
        </span>
      </div>

      <!-- Roles Selection -->
      <div class="space-y-2">
        <label for="input-roles" class="block text-sm font-medium text-gray-900 dark:text-white">
          Select Roles
        </label>
        <kendo-multiselect 
          id="input-roles" 
          class="w-full" 
          formControlName="roles"
          [data]="roles$" 
          [textField]="'name'" 
          [valueField]="'id'" 
          placeholder="Select roles..."
          [valuePrimitive]="true"
          [filterable]="true">
        </kendo-multiselect>
        <span *ngIf="f['roles']?.hasError('pattern') && f['roles']?.touched"
          class="text-sm text-red-600 dark:text-red-400">
          Invalid role pattern
        </span>
        <span *ngIf="f['roles']?.errors?.required && f['roles']?.touched" 
          class="text-sm text-red-600 dark:text-red-400">
          Role selection is required
        </span>
      </div>

      <!-- Submit Button -->
      <div class="flex justify-end pt-4 border-t border-gray-200 dark:border-gray-700">
        <button 
          kendoButton 
          [disabled]="submitted || !registerForm.valid"
          [class.btn-pulse]="submitted"
          class="bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400 dark:disabled:bg-gray-600 text-white px-6 py-2 rounded-md font-medium transition-colors">
          Create User
        </button>
      </div>
    </form>
  </div>
</div>
